export const applicationNames = [
  {
    id: 'sterling',
    displayName: 'MMS Retail'
  }, {
    id: 'webshop',
    displayName: 'Marketplace'
  }
];
